import React from 'react';

import FadeIn from 'legacy/common/components/transition/FadeIn';
import Header from 'legacy/common/components/wysiwyg-form/Header';

import MomentSettings from './settings/MomentSettings';
import MaxTicketsSettings from './settings/MaxTicketsSettings';
import GuestQuestionSetting from './settings/GuestQuestionSetting';
import TaxSettings from './settings/TaxSettings';
import TrackingLinksSettings from './settings/TrackingLinksSettings';
import WaiverSetting from './settings/WaiverSetting';
import DiscountCodesSettings from './settings/DiscountCodesSettings';
import EventOrganizerFee from './settings/EventOrganizerfee';
import DangerZone from './settings/DangerZone';
import MetaPixelSettings from './settings/MetaPixelSettings';
import MaxCapacitySettings from './settings/MaxCapacitySettings';
import OffersSettings from './settings/OffersSettings';
import { useEventEditorContext } from '../../contexts/EventEditorContext';

const EventSettings: React.FC = () => {
  const {
    eventId,
    navigateToTrackingLinks,
    navigateToDiscountCodes,
    navigateToSeriesSettings,
    navigateToOffersPage,
    refetchEvent,
    createDraft,
    setOffersStep,
    isDraft,
    isEditing,
    isLoading,
    lastUpdated,
    handleBack,
    navigateToEventSettings
  } = useEventEditorContext();

  return (
    <>
      <Header
        isDraft={isDraft}
        isEditing={isEditing}
        title="Event Settings"
        isLoading={isLoading}
        lastUpdated={lastUpdated}
        onBack={handleBack}
        onMenuClick={navigateToEventSettings}
      />
      <FadeIn>
        <div
          className="pt-[90px] md:pt-[180px] -mt-[90px] pb-20 md:w-[630px] md:mx-auto px-4 "
          onClick={async () => {
            // Create a draft if event has not been created yet
            if (!eventId) {
              await createDraft();
            }
          }}
        >
          <h3 className="text-lg font-semibold">Guest</h3>
          <WaiverSetting refetchEvent={refetchEvent} />
          <GuestQuestionSetting />

          <h3 className="mt-6 text-lg font-semibold">Analytics</h3>
          <TrackingLinksSettings
            eventId={eventId}
            navigateToTrackingLinks={navigateToTrackingLinks}
          />
          <DiscountCodesSettings
            eventId={eventId}
            navigateToDiscountCodes={navigateToDiscountCodes}
          />
          <OffersSettings
            eventId={eventId}
            navigateToOffers={navigateToOffersPage}
            setOffersStep={setOffersStep}
          />
          <MetaPixelSettings />

          <h3 className="mt-6 text-lg font-semibold">Advanced options</h3>
          <MaxTicketsSettings />
          <MaxCapacitySettings />
          <TaxSettings />
          <EventOrganizerFee />

          <MomentSettings />

          {eventId && (
            <DangerZone
              eventId={eventId}
              navigateToSeriesSettings={navigateToSeriesSettings}
            />
          )}
        </div>
      </FadeIn>
    </>
  );
};

export default EventSettings;
